import Linkify from "linkify-react";
import {
  createTokenClass,
  registerPlugin,
  ScannerInit,
  ParserInit,
  MultiToken,
} from "linkifyjs";

import { P } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

const MentionToken = createTokenClass("mention", {
  isLink: true,
  toHref() {
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    return "/" + this.toString().slice(1);
  },
}) as unknown as MultiToken;

/**
 * Mention parser plugin for linkify
 * @type {import('linkifyjs').Plugin}
 * https://github.com/nfrasser/linkifyjs/blob/f1f9df13ac1a450049e252e1ea213b5b33b31620/packages/linkify-plugin-mention/src/mention.mjs#L4
 */
function mention({
  scanner,
  parser,
}: {
  scanner: ScannerInit;
  parser: ParserInit;
}) {
  const { HYPHEN, SLASH, UNDERSCORE, AT, DOT } = scanner.tokens;
  const { domain } = scanner.tokens.groups;

  if (!domain) {
    return;
  }

  // @
  const At = parser.start.tt(AT); // @

  // Begin with hyphen (not mention unless contains other characters)
  const AtHyphen = At.tt(HYPHEN);
  AtHyphen.tt(HYPHEN, AtHyphen);

  // Valid mention (not made up entirely of symbols)
  const Mention = At.tt(UNDERSCORE, MentionToken);

  At.ta(domain, Mention);

  AtHyphen.tt(UNDERSCORE, Mention);
  AtHyphen.ta(domain, Mention);

  // More valid mentions
  Mention.ta(domain, Mention);
  Mention.tt(HYPHEN, Mention);
  Mention.tt(UNDERSCORE, Mention);
  Mention.tt(DOT, Mention);

  // Mention with a divider
  const MentionDivider = Mention.tt(SLASH);

  // Once we get a word token, mentions can start up again
  MentionDivider.ta(domain, Mention);
  MentionDivider.tt(UNDERSCORE, Mention);
  MentionDivider.tt(HYPHEN, Mention);
}

registerPlugin("mention", mention);

function Link({
  attributes,
  content,
}: {
  attributes: React.ComponentProps<"a">;
  content: React.ReactNode;
}) {
  return (
    <a {...attributes} className="text-current underline hover:text-blue-dim">
      {content}
    </a>
  );
}

export function Description({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <P className={cn("whitespace-pre-wrap", className)}>
      <Linkify
        options={{
          render: Link,
          formatHref: {
            mention: (href) => "https://bsky.app/profile/" + href,
          },
        }}
      >
        {children}
      </Linkify>
    </P>
  );
}
